import {useCallback, useRef} from 'react';
import {getUtmFieldCheckResult} from './utm-link-builder.library';
import {trackUtmFieldFilled} from './utm-link-builder-tracking.library';
import type {UtmFieldFilledTracking, UtmFormFieldName} from './utm-link-builder.types';

/**
 * One `UTMTool_Field_Filled` per finished edit: sent when focus leaves a field whose trimmed value is set and differs from the one it held
 * when focus arrived, so typing, tabbing past a field and Clear send nothing.
 */
export const useUtmFieldFilledTracking = (): UtmFieldFilledTracking => {
  const valuesAtFocus = useRef(new Map<UtmFormFieldName, string>());

  const onFieldFocus = useCallback((fieldName: UtmFormFieldName, value: string): void => {
    valuesAtFocus.current.set(fieldName, value.trim());
  }, []);

  const onFieldBlur = useCallback((fieldName: UtmFormFieldName, value: string): void => {
    const trimmedValue = value.trim();
    if (trimmedValue === '' || trimmedValue === valuesAtFocus.current.get(fieldName)) {
      return;
    }
    trackUtmFieldFilled(fieldName, getUtmFieldCheckResult(fieldName, value));
  }, []);

  return {onFieldFocus, onFieldBlur};
};
